import { createAction } from "@reduxjs/toolkit";

const enum ReopenReducer {
	setShowHeader = "[REOPEN] Set Show Header",
	endStep = "[REOPEN] End Step",
}

export const reopenSetShowHeader = createAction<boolean>(ReopenReducer.setShowHeader);

export const reopenEndStep = createAction<boolean>(ReopenReducer.endStep);
